// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qfmz","type":"styles_type__2iSvq","choices":"styles_choices__1wtXN"};